import { useKnowledgeDocumentUXContextOptional } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'

export function useIsGraphLocked(): boolean {
  const documentUX = useKnowledgeDocumentUXContextOptional()
  return Boolean(documentUX?.isLabelerMode || documentUX?.isEvalSessionLocked)
}
